<!-- changing button positon for US Literature listing page -->
<div
  edsPadding
  [edsPaddingTop]="
    componentName !== 'fundDocumentListing' &&
    componentName !== 'documentListing'
      ? 'sm'
      : ''
  "
  [edsPaddingBottom]="componentName !== 'fundDocumentListing' ? 'sm' : ''"
  edsFlexbox
  [justifyContent]="
    componentName === 'documentListing' && !isSiteIntl
      ? 'flex-start'
      : 'flex-end'
  "
>
  <ng-container
    *ngIf="loginRequired && showLogIn && !showExternalDocument; else loggedIn"
  >
    <div
      edsPadding
      [edsPaddingLeft]="componentName !== 'fundDocumentListing' ? 'sm' : ''"
    >
      <a
        edsButton="primary"
        size="compact"
        [noMargin]="true"
        (click)="signIn(documentDownloadLink)"
      >
        <eds-icon
          type="lock"
          size="small"
          edsPadding
          edsPaddingRight="xs"
        ></eds-icon>
        <span> {{ "literature.signin-register" | translate }}</span>
      </a>
    </div>
  </ng-container>
  <ng-template #loggedIn>
    <div edsFlexbox justifyContent="flex-end" flexDirection="column">
      <div edsFlexbox>
        <ng-container *ngIf="isColumnLayout">
          <ng-container *ngIf="isShowDownload; else downloadNotAvailble">
            <button
              [noMargin]="!isCartConfigured"
              size="compact"
              edsButton="primary"
              data-analytics-no-event="true"
              [ngClass]="
                params?.data?.literatureData?.fileExtension !== 'pdf'
                  ? 'document-download--margin-sm'
                  : ''
              "
              (click)="
                goToLink(params?.data?.literatureData, documentDownloadLink)
              "
            >
              <ng-container *ngIf="!showExternalDocument; else signRegister">
                {{ "literature.download" | translate }}
              </ng-container>
            </button>
          </ng-container>
          <button
            *ngIf="isCartConfigured"
            [edsButton]="addedInProgress ? 'secondary' : 'primary'"
            [ngClass]="
              addedInCart && !addedInProgress
                ? 'document-download--margin-sm'
                : ''
            "
            size="compact"
            [noMargin]="true"
            [disabled]="addedInProgress"
            (click)="updateCartHandler(params?.data, $event, addedInCart)"
          >
            <span *ngIf="addedInProgress">{{
              "literature.Updating-cart" | translate
            }}</span>
            <span *ngIf="!addedInProgress && addedInCart">
              {{ "literature.lit-sticky-delete-button" | translate }}
            </span>
            <span *ngIf="!addedInProgress && !addedInCart">{{
              "literature.Add-to-cart" | translate
            }}</span>
          </button>
        </ng-container>
        <ng-container *ngIf="!isColumnLayout">
          <ng-container *ngIf="isShowDownload; else downloadNotAvailble">
            <div edsPadding edsPaddingLeft="sm" edsPaddingRight="sm">
              <button
                [noMargin]="true"
                data-analytics-no-event="true"
                [edsButton]="isSiteIntl ? 'secondary' : 'primary'"
                [ngClass]="
                  params?.data?.literatureData?.fileExtension !== 'pdf'
                    ? 'document-download--margin-sm'
                    : ''
                "
                size="compact"
                (click)="
                  goToLink(params?.data?.literatureData, documentDownloadLink)
                "
              >
                <ng-container
                  *ngIf="
                    params?.data?.literatureData?.fileExtension === 'pdf';
                    else nonPdf
                  "
                >
                  <ng-container
                    *ngIf="!showExternalDocument; else signRegister"
                  >
                    {{ "literature.download" | translate }}
                  </ng-container>
                </ng-container>
                <ng-template #nonPdf>
                  <ng-container
                    *ngIf="!showExternalDocument; else signRegister"
                  >
                    {{ "literature.download" | translate }}
                  </ng-container>
                </ng-template>
                <eds-icon
                  type="download"
                  size="small"
                  edsPadding
                  edsPaddingLeft="xs"
                ></eds-icon>
              </button>
            </div>
          </ng-container>
          <button
            *ngIf="isCartConfigured"
            [edsButton]="addedInProgress ? 'primary' : 'secondary'"
            [ngClass]="
              addedInCart && !addedInProgress
                ? 'document-download--margin-sm'
                : ''
            "
            size="compact"
            [noMargin]="true"
            [disabled]="addedInProgress"
            (click)="updateCartHandler(params?.data, $event, addedInCart)"
          >
            <span *ngIf="addedInProgress">{{
              "literature.Updating-cart" | translate
            }}</span>
            <eds-icon
              *ngIf="!addedInProgress && addedInCart"
              type="cross"
              size="small"
              edsPadding
              edsPaddingRight="xs"
            ></eds-icon>
            <span *ngIf="!addedInProgress && addedInCart">
              {{ "literature.lit-sticky-delete-button" | translate }}
            </span>
            <span *ngIf="!addedInProgress && !addedInCart">{{
              "literature.Add-to-cart" | translate
            }}</span>
            <eds-icon
              type="cart"
              size="small"
              edsPadding
              edsPaddingLeft="xs"
              *ngIf="!addedInProgress && !addedInCart"
            ></eds-icon>
          </button>
        </ng-container>
        <a
          *ngIf="isDeleteEnable"
          (click)="deleteRow($event)"
          class="ag-cell-frk--link"
          title="{{ 'literature.delete' | translate }}"
          edsPadding
          edsPaddingLeft="sm"
        >
          {{ "literature.delete" | translate }}
        </a>
      </div>
      <ng-template #downloadNotAvailble>
        <div edsPadding edsPaddingLeft="sm" edsPaddingRight="sm">
          {{
            "literature.cart-download-unavailable-alert-body-msg" | translate
          }}
        </div>
      </ng-template>
      <eds-notifications
        edsPadding
        [edsPaddingTop]="(isMobile$ | async) ? 'xs' : ''"
        [edsPaddingBottom]="(isMobile$ | async) ? 'xs' : ''"
        [edsPaddingLeft]="componentName !== 'fundDocumentListing' ? 'sm' : ''"
        edsSpacing="none"
        [hasIcon]="true"
        *ngIf="addedInCart && params?.data?.literatureData?.isMandatoryMaterial"
        title="{{ 'literature.cart-mandatory-alert-body-msg' | translate }}"
        [inline]="true"
        notificationType="warning"
        [small]="true"
      >
      </eds-notifications>
      <eds-notifications
        edsSpacing="none"
        edsPadding
        [edsPaddingTop]="(isMobile$ | async) ? 'xs' : ''"
        [edsPaddingBottom]="(isMobile$ | async) ? 'xs' : ''"
        [edsPaddingLeft]="componentName !== 'fundDocumentListing' ? 'sm' : ''"
        *ngIf="
          isCartConfigured && params?.data?.literatureData?.hardCopyNotAvailable
        "
        [hasIcon]="true"
        title="{{ 'literature.cart-hardcopy-alert-body-msg' | translate }}"
        [inline]="true"
        notificationType="warning"
        [small]="true"
      >
      </eds-notifications>
    </div>
  </ng-template>
</div>

<ng-template #signRegister>
  {{ "literature.signin-register" | translate }}
</ng-template>
